(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(2));
	__export(__webpack_require__(3));
	__export(__webpack_require__(1));
	__export(__webpack_require__(4));


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function eq(a, b) {
	    var idx = 0;
	    if (a === b) {
	        return true;
	    }
	    if (typeof a.equals === 'function') {
	        return a.equals(b);
	    }
	    if (a.length > 0 && a.length === b.length) {
	        for (; idx < a.length; idx += 1) {
	            if (!eq(a[idx], b[idx])) {
	                return false;
	            }
	        }
	        return true;
	    }
	    return false;
	}
	exports.eq = eq;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var monad_1 = __webpack_require__(1);
	var EitherType;
	(function (EitherType) {
	    EitherType[EitherType["Left"] = 0] = "Left";
	    EitherType[EitherType["Right"] = 1] = "Right";
	})(EitherType = exports.EitherType || (exports.EitherType = {}));
	function exists(t) {
	    return t !== null && t !== undefined;
	}
	function either(l, r) {
	    if (exists(l) && exists(r)) {
	        throw new TypeError('Cannot construct an Either with both a left and a right');
	    }
	    if (!exists(l) && !exists(r)) {
	        throw new TypeError('Cannot construct an Either with neither a left nor a right');
	    }
	    if (exists(l) && !exists(r)) {
	        return Either.left(l);
	    }
	    if (!exists(l) && exists(r)) {
	        return Either.right(r);
	    }
	}
	exports.either = either;
	var Either = (function () {
	    function Either(type, l, r) {
	        this.type = type;
	        this.l = l;
	        this.r = r;
	        this.of = this.unit;
	        this.chain = this.bind;
	        this.lift = this.fmap;
	        this.map = this.fmap;
	    }
	    Either.left = function (l) {
	        return new Either(EitherType.Left, l);
	    };
	    Either.right = function (r) {
	        return new Either(EitherType.Right, null, r);
	    };
	    Either.prototype.unit = function (t) {
	        return Either.right(t);
	    };
	    Either.prototype.bind = function (f) {
	        return this.type === EitherType.Right ?
	            f(this.r) :
	            Either.left(this.l);
	    };
	    Either.prototype.fmap = function (f) {
	        var _this = this;
	        return this.bind(function (v) { return _this.unit(f(v)); });
	    };
	    Either.prototype.caseOf = function (pattern) {
	        return this.type === EitherType.Right ?
	            pattern.right(this.r) :
	            pattern.left(this.l);
	    };
	    Either.prototype.equals = function (other) {
	        return other.type === this.type &&
	            ((this.type === EitherType.Left && monad_1.eq(other.l, this.l)) ||
	                (this.type === EitherType.Right && monad_1.eq(other.r, this.r)));
	    };
	    Either.prototype.do = function (patterns) {
	        if (patterns === void 0) { patterns = {}; }
	        var noop_pattern = {
	            left: function (l) { },
	            right: function (r) { },
	        };
	        var merged = Object.assign(noop_pattern, patterns);
	        this.caseOf(merged);
	        return this;
	    };
	    return Either;
	}());
	exports.Either = Either;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var monad_1 = __webpack_require__(1);
	var MaybeType;
	(function (MaybeType) {
	    MaybeType[MaybeType["Nothing"] = 0] = "Nothing";
	    MaybeType[MaybeType["Just"] = 1] = "Just";
	})(MaybeType = exports.MaybeType || (exports.MaybeType = {}));
	function maybe(t) {
	    return Maybe.maybe(t);
	}
	exports.maybe = maybe;
	var Maybe = (function () {
	    function Maybe(type, value) {
	        this.type = type;
	        this.value = value;
	        this.of = this.unit;
	        this.chain = this.bind;
	        this.lift = this.fmap;
	        this.map = this.fmap;
	    }
	    Maybe.sequence = function (t) {
	        if (Object.keys(t).filter(function (k) { return t[k].type === MaybeType.Nothing; }).length) {
	            return Maybe.nothing();
	        }
	        var result = {};
	        for (var k in t) {
	            if (t.hasOwnProperty(k)) {
	                result[k] = t[k].value;
	            }
	        }
	        return Maybe.just(result);
	    };
	    Maybe.maybe = function (t) {
	        return t === null || t === undefined
	            ? new Maybe(MaybeType.Nothing)
	            : new Maybe(MaybeType.Just, t);
	    };
	    Maybe.just = function (t) {
	        if (t === null || t === undefined) {
	            throw new TypeError('Cannot Maybe.just(null)');
	        }
	        return new Maybe(MaybeType.Just, t);
	    };
	    Maybe.nothing = function () {
	        return new Maybe(MaybeType.Nothing);
	    };
	    Maybe.isJust = function (t) {
	        return t.type === MaybeType.Just;
	    };
	    Maybe.isNothing = function (t) {
	        return t.type === MaybeType.Nothing;
	    };
	    Maybe.prototype.unit = function (u) {
	        return Maybe.maybe(u);
	    };
	    Maybe.prototype.bind = function (f) {
	        return this.type === MaybeType.Just ?
	            f(this.value) :
	            Maybe.nothing();
	    };
	    Maybe.prototype.fmap = function (f) {
	        var _this = this;
	        return this.bind(function (v) { return _this.unit(f(v)); });
	    };
	    Maybe.prototype.caseOf = function (patterns) {
	        return this.type === MaybeType.Just ?
	            patterns.just(this.value) :
	            patterns.nothing();
	    };
	    Maybe.prototype.defaulting = function (defaultValue) {
	        return Maybe.just(this.valueOr(defaultValue));
	    };
	    Maybe.prototype.equals = function (other) {
	        return other.type === this.type &&
	            (this.type === MaybeType.Nothing || monad_1.eq(other.value, this.value));
	    };
	    Maybe.prototype.valueOr = function (defaultValue) {
	        return this.valueOrCompute(function () { return defaultValue; });
	    };
	    Maybe.prototype.valueOrCompute = function (defaultValueFunction) {
	        return this.type === MaybeType.Just ? this.value : defaultValueFunction();
	    };
	    Maybe.prototype.valueOrThrow = function (error) {
	        if (this.type === MaybeType.Just) {
	            return this.value;
	        }
	        throw (error || new Error('No value is available.'));
	    };
	    Maybe.prototype.do = function (patterns) {
	        if (patterns === void 0) { patterns = {}; }
	        var noop_pattern = {
	            just: function (t) { },
	            nothing: function () { },
	        };
	        var merged = Object.assign(noop_pattern, patterns);
	        this.caseOf(merged);
	        return this;
	    };
	    return Maybe;
	}());
	Maybe.all = function (t) { return Maybe.sequence(t); };
	exports.Maybe = Maybe;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function writer(story, value) {
	    return Writer.writer(story, value);
	}
	exports.writer = writer;
	var Writer = (function () {
	    function Writer(story, value) {
	        this.story = story;
	        this.value = value;
	        this.of = this.unit;
	        this.chain = this.bind;
	        this.lift = this.fmap;
	        this.map = this.fmap;
	    }
	    Writer.writer = function (story, value) {
	        return new Writer(story, value);
	    };
	    Writer.tell = function (s) {
	        return new Writer([s], 0);
	    };
	    Writer.prototype.unit = function (u) {
	        return new Writer([], u);
	    };
	    Writer.prototype.bind = function (f) {
	        var wu = f(this.value), newStory = this.story.concat(wu.story);
	        return new Writer(newStory, wu.value);
	    };
	    Writer.prototype.fmap = function (f) {
	        var _this = this;
	        return this.bind(function (v) { return _this.unit(f(v)); });
	    };
	    Writer.prototype.caseOf = function (patterns) {
	        return patterns.writer(this.story, this.value);
	    };
	    Writer.prototype.equals = function (other) {
	        var i, sameStory = true;
	        for (i = 0; i < this.story.length; i += 1) {
	            sameStory = sameStory && this.story[i] === other.story[i];
	        }
	        return sameStory && this.value === other.value;
	    };
	    return Writer;
	}());
	exports.Writer = Writer;


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// tsmonad.js